<mat-icon *ngIf="isLoading" class="margin-lg">
	<mat-spinner diameter="20"> </mat-spinner>
</mat-icon>
<div *ngIf="!isLoading">
	<form [formGroup]="form" class="margin-top-md">

		<div class="row gx-0">
			<mat-form-field class="col-lg-12">
				<mat-label>
					Workflow Name
				</mat-label>
				<input matInput type="string" placeholder="Workflow Name" formControlName="name" />
			</mat-form-field>

			<mat-form-field class="col-lg-12">
				<mat-label>Workflow Description</mat-label>
				<textarea matInput type="string" placeholder="Workflow Description"
					formControlName="description"></textarea>
			</mat-form-field>
			<mat-form-field class="col-lg-6">
				<mat-label>
					Workflow Node Type
				</mat-label>
				<mat-select formControlName="workflowNodeType">
					<mat-option *ngFor="let workflowNodeType of workflowNodeTypes" [value]="workflowNodeType">
						{{ workflowNodeType.NAME }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<confirm-popover [buttonType]="'string'" [buttonTxt]="'Save'" [color]="'primary'"
				[popoverMsg]="'Confirm saving workflow'" [popoverConfirmText]="'Save'" [popoverConfirmColor]="'primary'"
				(onConfirm)="updateWorkflow()" [disabled]="!form.valid" *ngIf="hasPermission">
			</confirm-popover>
		</div>
	</form>
</div>
<app-msg [msg]="msg"></app-msg>